import styled from "styled-components";
import {
  Flex,
  Type,
  Button,
  InputText,
} from "@ebscois/react-component-library";

export const CopyLinkWrapper = styled(Flex)`
  margin: 0;
`;

export const CopyLinkInput = styled(InputText)`
  margin-top: 0.75rem;
  margin-right: ${({ theme }) => theme.space.sm};
  margin-bottom: ${({ theme }) => theme.space.sm};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-right: 0;
    margin-left: 0;
  }
`;

export const CopyLinkButtonWrapper = styled(Flex)`
  padding-top: ${({ theme }) => theme.space.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-top: 0;
  }
`;

export const CopyLinkButton = styled(Button)`
  font-size: ${({ theme }) => theme.font.size.sm};
  padding-top: 6px;
  padding-bottom: 6px;
`;

export const CopiedLinkLabel = styled(Type)`
  padding-top: 5px;
  padding-bottom: 5px;
`;
